import React from 'react';
import { Nav } from 'react-bootstrap';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import { useSelector } from 'react-redux';
import checkIfUserIsSaml from '../../../../utility/checkIfUserIsSaml';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';

function ProfileSettingsNavTabs() {
  const { activeSubscription } = useSelector(selectSessionInformation);
  const isSamlUser = checkIfUserIsSaml(activeSubscription);
  const handleAddAccount = () => {
    window.location.href = '/user/add-subscription';
  };

  /* istanbul ignore next */
  return (
    <>
      <div className="clearfix text-right mb-3">
        <h4 className="float-left">
          Profile
          {' '}
          <a
            title="How To Request Access To A Room Alert Account & Approve New Users"
            href="https://avtech.com/articles/59/how-to-request-access-to-a-roomalert-subscription/"
            className="text-muted small"
            target="_blank"
            rel="noopener noreferrer"
            style={{ verticalAlign: '0.75em' }}
          >
            <span style={{ fontSize: 'smaller' }}>
              <Icon icon="circle-question" size="xs" />
            </span>
          </a>
        </h4>
        {!isSamlUser && (
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleAddAccount}
        >
          Add Account
        </button>
        )}
      </div>

      <Nav
        variant="tabs"
        className="mb-3"
        defaultActiveKey="/s/user/referrals"
      >

        <Nav.Item>
          <Nav.Link href="/user">Settings</Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link href="/user/subscriptions">Accounts</Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link href="/user/app-devices">App Devices</Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link href="/user/messages">Messages</Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link href="/s/user/referrals">Referrals</Nav.Link>
        </Nav.Item>
      </Nav>
    </>
  );
}
export default ProfileSettingsNavTabs;
